import axiosInstance from "../../../services/config/axiosinstance";
import AdminConfigModel from '../../../models/AdminConfigModel';
import { urlBaseAccreditation } from './../../config/index';

export default async function getConfigListApi(
  eventId = '',
) {
  try {
    const _config = {
      url: `${urlBaseAccreditation}/mobileConfig/getMobileConfigs?eventId=${eventId}`,
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
      },
    };

    const _ret = await axiosInstance(_config);

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    let _return = [];

    _ret.data.data.forEach((item) => {
      let _item = AdminConfigModel({
        id: item.id,
        fieldId: item.attributeId,
        value: item.value
      })
      _return.push(_item);
    });

    return _return;

  } catch (error) {
    console.log('Error getConfigListApi', error);
    throw error;
  }
}
